import BALogo from '../assets/micro-degree-new/md-card-bg-business-analyst.png'
import PBILogo from '../assets/micro-degree-new/md-card-bg-power-bi.png'


import PythonLogo from '../assets/micro-degree-new/md-card-bg-python.png'
import PythonAIMLLogo from '../assets/micro-degree-new/md-card-bg-python-aiml.png'
import AIMLLogo from '../assets/micro-degree-new/md-card-bg-aiml.png'
import DALogo from '../assets/micro-degree-new/md-card-bg-data-analysis.png'
import JavaLogo from '../assets/micro-degree-new/md-card-bg-java.png'
import AdvJavaLogo from '../assets/micro-degree-new/md-card-bg-adv-java.png'
import FrontendLogo from '../assets/micro-degree-new/md-card-bg-react.png'
import AWSLogo from '../assets/micro-degree-new/md-card-bg-AWS-C03.png'
import AWSCloudLogo from '../assets/micro-degree-new/md-card-bg-AWS-Cloud-Practitioner.png';

import DevOpsLogo from '../assets/micro-degree-new/md-card-bg-DevOps.png'
import AzureDevOpsLogo from '../assets/micro-degree-new/md-card-bg-AzureDevOps.png';
import TableauLogo from '../assets/micro-degree-new/md-card-bg-Tableau.png'
import KubernetesLogo from '../assets/micro-degree-new/md-card-bg-Kubernetes.png'
import DockerLogo from '../assets/micro-degree-new/md-card-bg-Docker.png'
import GCPLogo from '../assets/micro-degree-new/md-card-bg-GCP.png'
import CEHLogo from '../assets/micro-degree-new/md-card-bg-CEH-V12.png'
import Azure305Logo from '../assets/micro-degree-new/md-card-bg-AZ-305.png'

import PMPLogo from '../assets/micro-degree-new/md-card-bg-PMP.png';
import ITILLogo from '../assets/micro-degree-new/md-card-bg-ITIL4.png';
import DMLogo from '../assets/micro-degree-new/md-card-bg-dm.png'

import ScrumLogo from '../assets/micro-degree-new/md-card-bg-scrum.png'
import PRINCELogo from '../assets/micro-degree-new/md-card-bg-prince2.png'
import MultiCloudLogo from '../assets/micro-degree-new/md-card-bg-multi-cloud.png';

import MEAWS from '../assets/micro-degree-new/ME-AWS.png'
import MEAzure from '../assets/micro-degree-new/ME-Azure.png'
import MECEH from '../assets/micro-degree-new/ME-CEH.png'
import MEPMP from '../assets/micro-degree-new/ME-PMP2.png'

import FALogo from '../assets/micro-degree-new/md-card-bg-ba-finance.png'
import DSPYLogo from '../assets/micro-degree-new/md-card-bg-ds.png';
import NODEJSLogo from '../assets/micro-degree-new/md-card-bg-nodejs.png';
import DAPYLogo from '../assets/micro-degree-new/md-card-bg-da-python.png';
import AIFSLogo from '../assets/micro-degree-new/md-card-bg-fullstack-ai.png';
import GENAILogo from '../assets/micro-degree-new/md-card-bg-genai.png';
import MLPYLogo from '../assets/micro-degree-new/md-card-bg-ml-python.png';
import MERNLogo from '../assets/micro-degree-new/md-card-bg-fullstack-mern.png'

import CybersecurityLogo from '../assets/micro-degree-new/md-card-bg-cybersecurity.png'
import ExcelLogo from '../assets/micro-degree-new/md-card-bg-excel.png'
import AZ104Logo from '../assets/micro-degree-new/md-card-bg-AZ-104.png'

import CTLogoManagement from '../assets/micro-degree-new/md-card-bg-track-management.png';
import CTLogoCybersecurity from '../assets/micro-degree-new/md-card-bg-track-cybersecurity.png';
import CTLogoDSGenAI from '../assets/micro-degree-new/md-card-bg-track-genai.png';
import CTLogoMultiCloud from '../assets/micro-degree-new/md-card-bg-track-multi-cloud.png';

import { AIMLFees, AWSCloudFees, AdvJavaFees, AzureDevOpsFees, BAFees, CEHFees, DAFees, DMFees, DevOpsFees, DockerFees, FrontendFees, GCPFees, ITILFees, JavaFees, KubernetesFees, PMPFees, PowerBIFees, PythonAIMLFees, PythonFees, TableauFees, MultiCloudFees, DAUsingPythonFees, MLUsingPythonFees, DataScientistFees, GenerativeAIFees, FullStackAIFees, NodeJSFees, MERNFullStackFees, FAFees, AZ305Fees, AWS_SAA_C03_Fees, ExcelFees, AZ104Fees, CybersecurityCTFees, ManagementCTFees, DSGenAICTFees, MultiCloudDevOpsCTFees, CEHFeesv2 } from './MicroDegreeFees';
import RouteEndPoints from './RouteEndPoints';

const MDCoursesList = [
    {
        id: 0,
        name: "0. Digital Marketing",
        selected: false,
        idsList: [0]
    },
    {
        id: 1,
        name: "1. Frontend Development",
        selected: false,
        idsList: [1]
    },
    {
        id: 2,
        name: "2. Python For AI/ML",
        selected: false,
        idsList: [2]
    },
    {
        id: 3,
        name: "3. AI/ML",
        selected: false,
        idsList: [3]
    },
    {
        id: 4,
        name: "4. Java Development",
        selected: false,
        idsList: [4]
    },
    {
        id: 5,
        name: "5. Advanced Java Development",
        selected: false,
        idsList: [5]
    },
    {
        id: 6,
        name: "6. Data Analytics",
        selected: false,
        idsList: [6]
    },
    {
        id: 10,
        name: "10. Python Development",
        selected: false,
        idsList: [10]
    },
    {
        id: 12,
        name: "12. Business Analytics",
        selected: false,
        idsList: [12]
    },
    {
        id: 13,
        name: "13. Power BI",
        selected: false,
        idsList: [13]
    },
    {
        id: 14,
        name: "14. Devops Engineer",
        selected: false,
        idsList: [14]
    },
    {
        id: 15,
        name: "15. Docker Certified Associate",
        selected: false,
        idsList: [15]
    },
    {
        id: 16,
        name: "16. Certified Kubernetes Administrator",
        selected: false,
        idsList: [16]
    },
    {
        id: 17,
        name: "17. Tableau Certification",
        selected: false,
        idsList: [17]
    },
    {
        id: 18,
        name: "18. AWS Cloud Practitioner",
        selected: false,
        idsList: [18]
    },
    {
        id: 20,
        name: "20. Project Management Professional(PMP)",
        selected: false,
        idsList: [20]
    },
    {
        id: 21,
        name: "21. ITIL 4 Foundation",
        selected: false,
        idsList: [21]
    },
    {
        id: 22,
        name: "22. Azure Devops Engineer(AZ-400)",
        selected: false,
        idsList: [22]
    },
    {
        id: 23,
        name: "23. Google Cloud Architect",
        selected: false,
        idsList: [23]
    },
    {
        id: 24,
        name: "24. Ethical Hacking Certification",
        selected: false,
        idsList: [24]
    },
    {
        id: 25,
        name: "25. Multi Cloud Architect (AWS+Azure+GCP)",
        selected: false,
        idsList: [37, 36, 23]
    },
    {
        id: 26,
        name: "26. Microsoft Excel Expert",
        selected: false,
        idsList: [26]
    },
    {
        id: 27,
        name: "27. Data Analytics Using Python",
        selected: false,
        idsList: [27]
    },
    {
        id: 28,
        name: "28. Machine Learning Using Python",
        selected: false,
        idsList: [28]
    },
    {
        id: 29,
        name: "29. Data Science Using Python",
        selected: false,
        idsList: [27, 28]
    },
    {
        id: 30,
        name: "30. Generative AI Using Python",
        selected: false,
        idsList: [30]
    },
    {
        id: 31,
        name: "31. AI Fullstack Development",
        selected: false,
        idsList: [2, 27, 28, 30]
    },
    {
        id: 32,
        name: "32. Backend Development Using Nodejs",
        selected: false,
        idsList: [32]
    },
    {
        id: 33,
        name: "33. MERN Fullstack Development",
        selected: false,
        idsList: [1, 32]
    },
    {
        id: 34,
        name: "34. Finance Analytics",
        selected: false,
        idsList: [34]
    },
    {
        id: 35,
        name: "35. Azure Administrator Associate (AZ-104)",
        selected: false,
        idsList: [35]
    },
    {
        id: 36,
        name: "36. Azure Solutions Architect (AZ-305)",
        selected: false,
        idsList: [36]
    },
    {
        id: 37,
        name: "37. AWS Solutions Architect (SAA-C03)",
        selected: false,
        idsList: [37]
    },
    {
        id: 38,
        name: "38. Scrum",
        selected: false,
        idsList: [38]
    },
    {
        id: 39,
        name: "39. Agile",
        selected: false,
        idsList: [39]
    },
    {
        id: 40,
        name: "40. Leadership",
        selected: false,
        idsList: [40]
    },
    {
        id: 41,
        name: "41. Information Systems Security Certification",
        selected: false,
        idsList: [41]
    },
    {
        id: 42,
        name: "42. Aws Certified Security - Speciality",
        selected: false,
        idsList: [42]
    },
    {
        id: 43,
        name: "43. GenAI For Business",
        selected: false,
        idsList: [43]
    },
    {
        id: 401,
        name: "401. Cybersecurity Interview Prep",
        selected: false,
        idsList: [401]
    },
    {
        id: 402,
        name: "402. Management Interview Prep",
        selected: false,
        idsList: [402]
    },
    {
        id: 403,
        name: "403. Data Science Interview Prep",
        selected: false,
        idsList: [403]
    },
    {
        id: 404,
        name: "404. Mult-Cloud & Devops Interview Prep",
        selected: false,
        idsList: [404]
    },
    {
        id: 405,
        name: "405. Business Analytics Interview Prep",
        selected: false,
        idsList: [405]
    },
    {
        id: 406,
        name: "406. Wed Development Interview Prep",
        selected: false,
        idsList: [406]
    },
    {
        id: 500,
        name: "500. CT - Data Science With GenAI Career Track",
        selected: false,
        idsList: [12, 2, 27, 28, 30]
    },
    {
        id: 501,
        name: "501. CT - Cybersecurity Career Track",
        selected: false,
        idsList: [24, 10, 18, 41, 42]
    },
    {
        id: 502,
        name: "502. CT - Multi-Cloud & Devops Career Track",
        selected: false,
        idsList: [37, 36, 23, 14, 22]
    },
    {
        id: 503,
        name: "503. CT - Management Career Track",
        selected: false,
        idsList: [20, 21, 38, 39, 40]
    },
    {
        id: 991,
        name: '991.Mock Exam - AWS Solutions Architect (SAA-C03)',
        selected: false,
        idsList: [991]
    },
    {
        id: 992,
        name: '992. Mock Exam - Azure Solutions Architect (AZ-305)',
        selected: false,
        idsList: [992]
    },
    {
        id: 993,
        name: "993. Mock Exam - Project Management Professional",
        selected: false,
        idsList: [993]
    },
    {
        id: 994,
        name: "994. Mock Exam - Ethical Hacking Certification",
        selected: false,
        idsList: [994]
    },
    {
        id: 995,
        name: "995. Mock Exam - GCP Mock Exam",
        selected: false,
        idsList: [995]
    },
    {
        id: 996,
        name: "996. Mock Exam - DevOps Mock Exam",
        selected: false,
        idsList: [996]
    }
]

export default MDCoursesList;

export const mdCoursesForNotificationDropdown = [
    {
        id: -1,
        label: "-",
        value: -1,
    },
    {
        id: 0,
        label: "Digital Marketing",
        value: 0,
    },
    {
        id: 1,
        label: "Frontend Development",
        value: 1,
    },
    {
        id: 2,
        label: "Python for AI/ML",
        value: 2,
    },
    {
        id: 3,
        label: "AI/ML Micro Degree",
        value: 3,
    },
    {
        id: 4,
        label: "Java Development",
        value: 4,
    },
    {
        id: 5,
        label: "Advanced Java Development",
        value: 5,
    },
    {
        id: 6,
        label: "Data Analysis",
        value: 6,
    },
    {
        id: 10,
        label: "Python Development",
        value: 10,
    },
    {
        id: 12,
        label: "Business Analytics",
        value: 12,
    },
    {
        id: 13,
        label: "Power BI",
        value: 13,
    },
    {
        id: 14,
        label: "Devops Engineer",
        value: 14,
    },
    {
        id: 15,
        label: "Docker Certified Associate",
        value: 15,
    },
    {
        id: 16,
        label: "Certified Kubernetes Administrator",
        value: 16,
    },
    {
        id: 17,
        label: "Tableau Certification",
        value: 17,
    },
    {
        id: 18,
        label: "AWS Cloud Practitioner",
        value: 18,
    },
    {
        id: 20,
        label: "Project Management Professional(PMP)",
        value: 20,
    },
    {
        id: 21,
        label: "ITIL 4 Foundation",
        value: 21,
    },
    {
        id: 22,
        label: "Azure Devops Engineer (AZ-400)",
        value: 22,
    },
    {
        id: 23,
        label: "Google Cloud Architect",
        value: 23,
    },
    {
        id: 24,
        label: "Ethical Hacking Certification",
        value: 24,
    },
    {
        id: 26,
        label: "Microsoft Excel Expert",
        value: 26,
    },
    {
        id: 27,
        label: "Data Analysis Using Python",
        value: 27,
    },
    {
        id: 28,
        label: "Machine Learning Using Python",
        value: 28,
    },
    {
        id: 30,
        label: "Generative AI Using Python",
        value: 30,
    },
    {
        id: 32,
        label: "Backend Development Using NodeJS",
        value: 32,
    },
    {
        id: 34,
        label: "Finance Analytics",
        value: 34,
    },
    {
        id: 35,
        label: "Azure Administrator Associate (AZ-104)",
        value: 35,
    },
    {
        id: 36,
        label: "Azure Solutions Architect (AZ-305)",
        value: 36,
    },
    {
        id: 37,
        label: "Aws Solutions Architect (SAA-C03)",
        value: 37,
    },
    {
        id: 38,
        label: "Scrum",
        value: 38,
    },
    {
        id: 39,
        label: "Agile",
        value: 39,
    },
    {
        id: 40,
        label: "Leadership",
        value: 40,
    },
    {
        id: 41,
        label: "Information Systems Security Certification",
        value: 41,
    },
    {
        id: 42,
        label: "AWS Certified Security - Speciality",
        value: 42,
    },
    {
        id: 43,
        label: "GenAI For Business",
        value: 43,
    },
    {
        id: 45,
        label: "Microsoft Azure Fundamentals Certification (AZ-900)",
        value: 45,
    },
    {
        id: 46,
        label: "SQL Developer",
        value: 46,
    },
    {
        id: 47,
        label: "Big Data using Hadoop, PySpark & Kafka",
        value: 47,
    },
    {
        id: 48,
        label: "AWS Certified Data Engineer - Associate (DEA-C01)",
        value: 48,
    },
    {
        id: 50,
        label: "AI Agent Development with GenAI",
        value: 50,
    },
    {
        id: 51,
        label: "Jenkins, Ansible & Terraform",
        value: 51,
    },
    {
        id: 54,
        label: "Splunk SIEM Security",
        value: 54,
    },
    {
        id: 55,
        label: "Vibe Coding using GenAI",
        value: 55,
    },
    {
        id: 401,
        label: "Interview Prep - Cybersecurity",
        value: 401,
    },
    {
        id: 402,
        label: "Interview Prep - Management",
        value: 402,
    },
    {
        id: 403,
        label: "Interview Prep - Data Science",
        value: 403,
    },
    {
        id: 404,
        label: "Interview Prep - Mult-Cloud & Devops",
        value: 404,
    },
    {
        id: 405,
        label: "Interview Prep - Business Analytics",
        value: 405,
    },
    {
        id: 406,
        label: "Interview Prep - Wed Development",
        value: 406,
    },
    {
        id: 991,
        label: "ME - Solutions Architect (SAA-C03)",
        value: 991,
    },
    {
        id: 992,
        label: "ME - Azure Solutions Architect (AZ-305)",
        value: 992,
    },
    {
        id: 993,
        label: "ME - Project Management Professional",
        value: 993,
    },
    {
        id: 994,
        label: "ME - Ethical Hacking Certification",
        value: 994,
    },
    {
        id: 995,
        label: "ME - GCP",
        value: 995,
    },
    {
        id: 996,
        label: "ME - DevOps",
        value: 996,
    }
]

export const MDCourseCardsList = {
    'DigitalMarketing': {
        id: 0,
        title: 'Digital Marketing',
        duration: '4 Weeks',
        commitment: 'Full Time/Part Time',
        mode: 'Live Instructor-led Sessions',
        startDate: '30 October 2023',
        seatsFull: false,
        logo: DMLogo,
        url: RouteEndPoints.DIGITAL_MARKETING_MICRO_DEGREE,
        enrollCount: 1.1,
        actualPrice: DMFees.totalFees,
        discountedPrice: DMFees.discountedFees
    },
    'AIML': {
        id: 3,
        title: 'Aritificial Intelligence & Machine Learning',
        duration: '4 Weeks',
        commitment: 'Full Time/Part Time',
        mode: 'Live Instructor-led Sessions',
        startDate: '30 October 2023',
        seatsFull: false,
        logo: AIMLLogo,
        url: RouteEndPoints.AI_ML_MICRO_DEGREE_NEW,
        isMostEnrolled: true,
        enrollCount: 1.2,
        actualPrice: AIMLFees.totalFees,
        discountedPrice: AIMLFees.discountedFees
    },
    'MLusingPY': {
        id: 28,
        title: 'Machine Learning using Python',
        duration: '6 Weeks',
        commitment: 'Full Time/Part Time',
        mode: 'Live Instructor-led Sessions',
        startDate: '15 November 2023',
        seatsFull: false,
        logo: MLPYLogo,
        url: RouteEndPoints.MACHINE_LEARNING_USING_PYTHON,
        enrollCount: 3.9,
        actualPrice: MLUsingPythonFees.totalFees,
        discountedPrice: MLUsingPythonFees.discountedFees
    },
    'DSusingPY': {
        id: 29,
        title: 'Data Science using Python',
        duration: '12 Weeks',
        commitment: 'Full Time/Part Time',
        mode: 'Live Instructor-led Sessions',
        startDate: '15 November 2023',
        seatsFull: false,
        logo: DSPYLogo,
        url: RouteEndPoints.DATA_SCIENCE_USING_PYTHON,
        enrollCount: 4.7,
        actualPrice: DataScientistFees.totalFees,
        discountedPrice: DataScientistFees.discountedFees
    },
    'GenAI': {
        id: 30,
        title: 'Generative AI using Python',
        duration: '6 Weeks',
        commitment: 'Full Time/Part Time',
        mode: 'Live Instructor-led Sessions',
        startDate: '15 November 2023',
        seatsFull: false,
        logo: GENAILogo,
        url: RouteEndPoints.GENERATIVE_AI_USING_PYTHON,
        enrollCount: 4.4,
        actualPrice: GenerativeAIFees.totalFees,
        discountedPrice: GenerativeAIFees.discountedFees
    },
    'AIFullStack': {
        id: 31,
        title: 'AI FullStack Development',
        duration: '16 Weeks',
        commitment: 'Full Time/Part Time',
        mode: 'Live Instructor-led Sessions',
        startDate: '15 November 2023',
        seatsFull: false,
        logo: AIFSLogo,
        url: RouteEndPoints.AI_FULLSTACK_DEVELOPMENT,
        enrollCount: 4.5,
        actualPrice: FullStackAIFees.totalFees,
        discountedPrice: FullStackAIFees.discountedFees
    },
    'MultiCloud': {
        id: 25,
        title: 'Multi Cloud Architect',
        duration: '12 Weeks',
        commitment: 'Full Time/Part Time',
        mode: 'Live Instructor-led Sessions',
        startDate: '15 November 2023',
        seatsFull: false,
        logo: MultiCloudLogo,
        url: RouteEndPoints.MULTI_CLOUD_MICRO_DEGREE,
        enrollCount: 7.4,
        actualPrice: MultiCloudFees.totalFees,
        discountedPrice: MultiCloudFees.discountedFees
    },
    'AWSSAA-C03': {
        id: 37,
        title: 'AWS Solutions Architect(SAA-C03)',
        duration: '6 Weeks',
        commitment: 'Full Time/Part Time',
        mode: 'Live Instructor-led Sessions',
        startDate: '15 November 2023',
        seatsFull: false,
        logo: AWSLogo,
        url: RouteEndPoints.AWS_SAA_C03_MICRO_DEGREE,
        enrollCount: 5.7,
        actualPrice: AWS_SAA_C03_Fees.totalFees,
        discountedPrice: AWS_SAA_C03_Fees.discountedFees
    },
    'AzureAZ-305': {
        id: 36,
        title: 'Azure Solutions Architect (AZ-305)',
        duration: '6 Weeks',
        commitment: 'Full Time/Part Time',
        mode: 'Live Instructor-led Sessions',
        startDate: '15 November 2023',
        seatsFull: false,
        logo: Azure305Logo,
        url: RouteEndPoints.AZURE_SOLUTIONS_ARCHITECT_305,
        enrollCount: 4.9,
        actualPrice: AZ305Fees.totalFees,
        discountedPrice: AZ305Fees.discountedFees
    },
    'GCP': {
        id: 23,
        title: 'Google Cloud Architect',
        duration: '4 Weeks',
        commitment: 'Full Time/Part Time',
        mode: 'Live Instructor-led Sessions',
        startDate: '15 November 2023',
        seatsFull: false,
        logo: GCPLogo,
        url: RouteEndPoints.GCP_CLOUD_ARCHITECT_MICRO_DEGREE,
        enrollCount: 6.4,
        actualPrice: GCPFees.totalFees,
        discountedPrice: GCPFees.discountedFees
    },
    'AzureDevOps': {
        id: 22,
        title: 'Azure DevOps Engineer',
        duration: '8 Weeks',
        commitment: 'Full Time/Part Time',
        mode: 'Live Instructor-led Sessions',
        startDate: '30 October 2023',
        seatsFull: false,
        logo: AzureDevOpsLogo,
        url: RouteEndPoints.AZURE_DEVOPS_MICRO_DEGREE,
        enrollCount: 3.9,
        actualPrice: AzureDevOpsFees.totalFees,
        discountedPrice: AzureDevOpsFees.discountedFees
    },
    'DevOps': {
        id: 14,
        title: 'DevOps Engineer',
        duration: '8 Weeks',
        commitment: 'Full Time/Part Time',
        mode: 'Live Instructor-led Sessions',
        startDate: '30 October 2023',
        seatsFull: false,
        logo: DevOpsLogo,
        url: RouteEndPoints.DEVOPS_MICRO_DEGREE,
        enrollCount: 4.3,
        actualPrice: DevOpsFees.totalFees,
        discountedPrice: DevOpsFees.discountedFees
    },
    'Kubernetes': {
        id: 16,
        title: 'Certified Kubernetes Administrator',
        duration: '3 Weeks',
        commitment: 'Full Time/Part Time',
        mode: 'Live Instructor-led Sessions',
        startDate: '30 October 2023',
        seatsFull: false,
        logo: KubernetesLogo,
        url: RouteEndPoints.KUBERNETES_MICRO_DEGREE,
        enrollCount: 3.5,
        actualPrice: KubernetesFees.totalFees,
        discountedPrice: KubernetesFees.discountedFees
    },
    'Docker': {
        id: 15,
        title: 'Docker Certified Associate',
        duration: '3 Weeks',
        commitment: 'Full Time/Part Time',
        mode: 'Live Instructor-led Sessions',
        startDate: '30 October 2023',
        seatsFull: false,
        logo: DockerLogo,
        url: RouteEndPoints.DOCKER_MICRO_DEGREE,
        enrollCount: 3.2,
        actualPrice: DockerFees.totalFees,
        discountedPrice: DockerFees.discountedFees
    },
    'ME-AWSSA': {
        id: 37,
        title: 'AWS Solutions Architect (SAA-C03)',
        duration: '6 Weeks',
        commitment: 'Full Time/Part Time',
        mode: 'Live Instructor-led Sessions',
        startDate: '15 November 2023',
        seatsFull: false,
        logo: MEAWS,
        url: RouteEndPoints.AWS_MOCK_EXAM,
        enrollCount: 5.7,
    },
    'ME-AzureAZ-305': {
        id: 36,
        title: 'Azure Solutions Architect (AZ-305)',
        duration: '6 Weeks',
        commitment: 'Full Time/Part Time',
        mode: 'Live Instructor-led Sessions',
        startDate: '15 November 2023',
        seatsFull: false,
        logo: MEAzure,
        url: RouteEndPoints.AZURE_MOCK_EXAM,
        enrollCount: 4.9,
    },
    'ME-PMP': {
        id: 20,
        title: 'Project Management Professional (PMP)',
        duration: '4 Weeks',
        commitment: 'Full Time/Part Time',
        mode: 'Live Instructor-led Sessions',
        startDate: '15 November 2023',
        seatsFull: false,
        logo: MEPMP,
        url: RouteEndPoints.PMP_MOCK_EXAM,
        enrollCount: 3.5,
    },
    'ME-CEH': {
        id: 24,
        title: 'Ethical Hacking Certification',
        duration: '5 Weeks',
        commitment: 'Full Time/Part Time',
        mode: 'Live Instructor-led Sessions',
        startDate: '15 November 2023',
        seatsFull: false,
        logo: MECEH,
        url: RouteEndPoints.CEH_V12_MOCK_EXAM,
        enrollCount: 4.3,
    },
    'BA': {
        id: 12,
        title: 'Business Analytics',
        duration: '8 Weeks',
        commitment: 'Full Time/Part Time',
        mode: 'Live Instructor-led Sessions',
        startDate: '15 November 2023',
        seatsFull: false,
        logo: BALogo,
        url: RouteEndPoints.BA_MICRO_DEGREE,
        enrollCount: 3.5,
        actualPrice: BAFees.totalFees,
        discountedPrice: BAFees.discountedFees
    },
    'PBI': {
        id: 13,
        title: 'Power BI',
        duration: '4 Weeks',
        commitment: 'Full Time/Part Time',
        mode: 'Live Instructor-led Sessions',
        startDate: '15 November 2023',
        seatsFull: false,
        logo: PBILogo,
        url: RouteEndPoints.POWER_BI_MICRO_DEGREE,
        enrollCount: 2.8,
        actualPrice: PowerBIFees.totalFees,
        discountedPrice: PowerBIFees.discountedFees
    },
    'DA': {
        id: 6,
        title: 'Data Analytics',
        duration: '4 Weeks',
        commitment: 'Full Time/Part Time',
        mode: 'Live Instructor-led Sessions',
        startDate: '13 November 2023',
        seatsFull: false,
        logo: DALogo,
        url: RouteEndPoints.DATA_ANALYSIS_MICRO_DEGREE,
        enrollCount: 3,
        actualPrice: DAFees.totalFees,
        discountedPrice: DAFees.discountedFees
    },
    'FA': {
        id: 34,
        title: 'Finance Analytics',
        duration: '8 Weeks',
        commitment: 'Full Time/Part Time',
        mode: 'Live Instructor-led Sessions',
        startDate: '15 November 2023',
        seatsFull: false,
        logo: FALogo,
        url: RouteEndPoints.FA_MICRO_DEGREE,
        enrollCount: 3.5,
        actualPrice: FAFees.totalFees,
        discountedPrice: FAFees.discountedFees
    },
    'PMP': {
        id: 20,
        title: 'Project Management Professional',
        duration: '4 Weeks',
        commitment: 'Full Time/Part Time',
        mode: 'Live Instructor-led Sessions',
        startDate: '15 November 2023',
        seatsFull: false,
        logo: PMPLogo,
        url: RouteEndPoints.PMP_MICRO_DEGREE,
        enrollCount: 3.5,
        actualPrice: PMPFees.totalFees,
        discountedPrice: PMPFees.discountedFees
    },
    'ITIL': {
        id: 21,
        title: 'ITIL 4 Foundation',
        duration: '4 Weeks',
        commitment: 'Full Time/Part Time',
        mode: 'Live Instructor-led Sessions',
        startDate: '15 November 2023',
        seatsFull: false,
        logo: ITILLogo,
        url: RouteEndPoints.ITIL_FOUNDATION_MICRO_DEGREE,
        enrollCount: 3.7,
        actualPrice: ITILFees.totalFees,
        discountedPrice: ITILFees.discountedFees
    },
    'ScrumMaster': {
        id: 211,
        title: 'Certified Scrum Master',
        duration: '4 Weeks',
        commitment: 'Full Time/Part Time',
        mode: 'Live Instructor-led Sessions',
        startDate: '15 November 2023',
        seatsFull: false,
        logo: ScrumLogo,
        url: '',
        enrollCount: 3.7,
        actualPrice: ITILFees.totalFees,
        discountedPrice: ITILFees.discountedFees,
        upcoming: true
    },
    'PRINCE2': {
        id: 212,
        title: 'PRINCE2®  Foundation and Practitioner',
        duration: '4 Weeks',
        commitment: 'Full Time/Part Time',
        mode: 'Live Instructor-led Sessions',
        startDate: '15 November 2023',
        seatsFull: false,
        logo: PRINCELogo,
        url: '',
        enrollCount: 3.7,
        actualPrice: ITILFees.totalFees,
        discountedPrice: ITILFees.discountedFees,
        upcoming: true
    },
    'MERNFS': {
        id: 33,
        title: 'MERN FullStack Development',
        duration: '10 Weeks',
        commitment: 'Full Time/Part Time',
        mode: 'Live Instructor-led Sessions',
        startDate: '15 November 2023',
        seatsFull: false,
        logo: MERNLogo,
        url: RouteEndPoints.MERN_FULLSTACK_DEVELOPMENT,
        enrollCount: 3.2,
        actualPrice: MERNFullStackFees.totalFees,
        discountedPrice: MERNFullStackFees.discountedFees
    },
    'NodeJS': {
        id: 32,
        title: 'Backend Development using NodeJS',
        duration: '6 Weeks',
        commitment: 'Full Time/Part Time',
        mode: 'Live Instructor-led Sessions',
        startDate: '15 November 2023',
        seatsFull: false,
        logo: NODEJSLogo,
        url: RouteEndPoints.BACKEND_DEVELOPMENT_USING_NODEJS,
        enrollCount: 4.3,
        actualPrice: NodeJSFees.totalFees,
        discountedPrice: NodeJSFees.discountedFees
    },
    'Frontend': {
        id: 1,
        title: 'Frontend Development',
        duration: '4 Weeks',
        commitment: 'Full Time/Part Time',
        mode: 'Live Instructor-led Sessions',
        startDate: '15 November 2023',
        seatsFull: false,
        logo: FrontendLogo,
        url: RouteEndPoints.FRONTEND_DEVELOPMENT_MICRO_DEGREE,
        enrollCount: 3.2,
        actualPrice: FrontendFees.totalFees,
        discountedPrice: FrontendFees.discountedFees
    },
    'AWSCP': {
        id: 18,
        title: 'AWS Cloud Practitioner',
        duration: '4 Weeks',
        commitment: 'Full Time/Part Time',
        mode: 'Live Instructor-led Sessions',
        startDate: '15 November 2024',
        seatsFull: false,
        logo: AWSCloudLogo,
        url: RouteEndPoints.AWS_CLOUD_PRACTITIONER_MICRO_DEGREE,
        enrollCount: 5.7,
        actualPrice: AWSCloudFees.totalFees,
        discountedPrice: AWSCloudFees.discountedFees
    },
    'PYTHON': {
        id: 10,
        title: 'Python Development',
        duration: '4 Weeks',
        commitment: 'Full Time/Part Time',
        mode: 'Live Instructor-led Sessions',
        startDate: '27 October 2023',
        seatsFull: false,
        logo: PythonLogo,
        url: RouteEndPoints.PYTHON_DEVELOPMENT_MICRO_DEGREE,
        isMostEnrolled: true,
        enrollCount: 2.4,
        actualPrice: PythonFees.totalFees,
        discountedPrice: PythonFees.discountedFees
    },
    'PYforAIML': {
        id: 2,
        title: 'Python for AI/ML',
        duration: '6 Weeks',
        commitment: 'Full Time/Part Time',
        mode: 'Live Instructor-led Sessions',
        startDate: '27 October 2023',
        seatsFull: false,
        logo: PythonAIMLLogo,
        url: RouteEndPoints.PYTHON_DEVELOPER_MICRO_DEGREE,
        isMostEnrolled: true,
        enrollCount: 7.9,
        actualPrice: PythonAIMLFees.totalFees,
        discountedPrice: PythonAIMLFees.discountedFees
    },
    'JAVA': {
        id: 4,
        title: 'Java Development',
        duration: '4 Weeks',
        commitment: 'Full Time/Part Time',
        mode: 'Live Instructor-led Sessions',
        startDate: '30 October 2023',
        seatsFull: false,
        logo: JavaLogo,
        url: RouteEndPoints.JAVA_DEVELOPER_MICRO_DEGREE,
        enrollCount: 2.6,
        actualPrice: JavaFees.totalFees,
        discountedPrice: JavaFees.discountedFees
    },
    'ADVJAVA': {
        id: 5,
        title: 'Advanced Java Development',
        duration: '4 Weeks',
        commitment: 'Full Time/Part Time',
        mode: 'Live Instructor-led Sessions',
        startDate: '30 October 2023',
        seatsFull: false,
        logo: AdvJavaLogo,
        url: RouteEndPoints.JAVA_DEVELOPER_ADVANCED_MICRO_DEGREE,
        enrollCount: 1.5,
        actualPrice: AdvJavaFees.totalFees,
        discountedPrice: AdvJavaFees.discountedFees
    },
    'CEH': {
        id: 24,
        title: 'Ethical Hacking Certification',
        duration: '5 Weeks',
        commitment: 'Full Time/Part Time',
        mode: 'Live Instructor-led Sessions',
        startDate: '15 November 2023',
        seatsFull: false,
        logo: CEHLogo,
        url: RouteEndPoints.CEH_V12_MICRO_DEGREE,
        enrollCount: 4.3,
        actualPrice: CEHFees.totalFees,
        discountedPrice: CEHFees.discountedFees
    },
    'CYBERSECURITY': {
        id: 24,
        title: 'Certified Cybersecurity Expert',
        duration: '5 Weeks',
        commitment: 'Full Time/Part Time',
        mode: 'Live Instructor-led Sessions',
        startDate: '15 November 2023',
        seatsFull: false,
        logo: CybersecurityLogo,
        url: RouteEndPoints.CYBER_SECURITY_MICRO_DEGREE,
        enrollCount: 4.3,
        actualPrice: CEHFeesv2.totalFees,
        discountedPrice: CEHFeesv2.discountedFees
    },
    'DAusingPY': {
        id: 27,
        title: 'Data Analysis using Python',
        duration: '6 Weeks',
        commitment: 'Full Time/Part Time',
        mode: 'Live Instructor-led Sessions',
        startDate: '15 November 2023',
        seatsFull: false,
        logo: DAPYLogo,
        url: RouteEndPoints.DATA_ANALYSIS_USING_PYTHON,
        enrollCount: 4.2,
        actualPrice: DAUsingPythonFees.totalFees,
        discountedPrice: DAUsingPythonFees.discountedFees
    },
    'TABLEAU': {
        id: 17,
        title: 'Tableau Developer',
        duration: '3 Weeks',
        commitment: 'Full Time/Part Time',
        mode: 'Live Instructor-led Sessions',
        startDate: '15 November 2023',
        seatsFull: false,
        logo: TableauLogo,
        url: RouteEndPoints.TABLEAU_MICRO_DEGREE,
        enrollCount: 4.2,
        actualPrice: TableauFees.totalFees,
        discountedPrice: TableauFees.discountedFees
    },
    'EXCEL': {
        id: 26,
        title: 'Microsoft Excel Expert',
        duration: '6 Weeks',
        commitment: 'Full Time/Part Time',
        mode: 'Live Instructor-led Sessions',
        startDate: '15 November 2023',
        seatsFull: false,
        logo: ExcelLogo,
        url: RouteEndPoints.EXCEL_MICRO_DEGREE,
        enrollCount: 4.2,
        actualPrice: ExcelFees.totalFees,
        discountedPrice: ExcelFees.discountedFees
    },
    'AzureAZ-104': {
        id: 35,
        title: 'Azure Administrator Associate (AZ-104)',
        duration: '6 Weeks',
        commitment: 'Full Time/Part Time',
        mode: 'Live Instructor-led Sessions',
        startDate: '15 November 2023',
        seatsFull: false,
        logo: AZ104Logo,
        url: RouteEndPoints.AZURE_ADMINISTRATOR_ASSOCIATE_104,
        enrollCount: 4.2,
        actualPrice: AZ104Fees.totalFees,
        discountedPrice: AZ104Fees.discountedFees
    },

    'CT-MultiCloudDevOps': {
        id: 502,
        title: 'Multi-cloud & DevOps Career Track',
        duration: '24 Weeks',
        commitment: 'Full Time/Part Time',
        mode: 'Live Instructor-led Sessions',
        startDate: '15 November 2023',
        seatsFull: false,
        logo: CTLogoMultiCloud,
        url: RouteEndPoints.MULTI_CLOUD_DEVOPS_CAREER_TRACK_MICRO_DEGREE,
        enrollCount: 3.9,
        actualPrice: MultiCloudDevOpsCTFees.totalFees,
        discountedPrice: MultiCloudDevOpsCTFees.discountedFees
    },
    'CT-Cybersecurity': {
        id: 501,
        title: 'Cybersecurity Career Track',
        duration: '24 Weeks',
        commitment: 'Full Time/Part Time',
        mode: 'Live Instructor-led Sessions',
        startDate: '15 November 2023',
        seatsFull: false,
        logo: CTLogoCybersecurity,
        url: RouteEndPoints.CYBER_SECURITY_CAREER_TRACK_MICRO_DEGREE,
        enrollCount: 5.2,
        actualPrice: CybersecurityCTFees.totalFees,
        discountedPrice: CybersecurityCTFees.discountedFees
    },
    'CT-Management': {
        id: 503,
        title: 'Management Career Track',
        duration: '24 Weeks',
        commitment: 'Full Time/Part Time',
        mode: 'Live Instructor-led Sessions',
        startDate: '15 November 2023',
        seatsFull: false,
        logo: CTLogoManagement,
        url: RouteEndPoints.MANAGEMENT_CAREER_TRACK_MICRO_DEGREE,
        enrollCount: 4.7,
        actualPrice: ManagementCTFees.totalFees,
        discountedPrice: ManagementCTFees.discountedFees
    },
    'CT-DSGenAIAI': {
        id: 500,
        title: 'Data Science with GenAI Career Track',
        duration: '24 Weeks',
        commitment: 'Full Time/Part Time',
        mode: 'Live Instructor-led Sessions',
        startDate: '15 November 2023',
        seatsFull: false,
        logo: CTLogoDSGenAI,
        url: RouteEndPoints.DSAI_CAREER_TRACK_MICRO_DEGREE,
        enrollCount: 5.6,
        actualPrice: DSGenAICTFees.totalFees,
        discountedPrice: DSGenAICTFees.discountedFees
    },
}